import { types } from "../action-types";

const initialState = {
  loading: false,
  project: null,
  jobs: [],
  counts: {},
  talents: [],
  talentsCount: 0,
  managers: [],
  managersCount: 0,
  error: false,
  history: [],
  historyLoading: false,
  addManagerLoading: false,
  addManagerSuccess: false,
};

const projectDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PROJECT_DETAIL_INIT:
      return { ...state, loading: true, project: null, jobs: [], counts: {}, talents: [], talentsCount: 0, managers: [], managersCount: 0, error: false };
    case types.FETCH_PROJECT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        project: action.payload.project,
        jobs: action.payload.jobs,
        counts: action.payload.counts,
        talents: action.payload.talents,
        talentsCount: action.payload.talentsCount,
        managers: action.payload.managers,
        managersCount: action.payload.managersCount,
      };
    case types.FETCH_PROJECT_DETAIL_FAILURE:
      return { ...state, loading: false, error: true };
    case types.FETCH_PROJECT_HISTORY_INIT:
      return { ...state, historyLoading: true, history: [] };
    case types.FETCH_PROJECT_HISTORY_SUCCESS:
      return { ...state, historyLoading: false, history: action.payload };
    case types.FETCH_PROJECT_HISTORY_FAILURE:
      return { ...state, historyLoading: false };
    case types.ADD_PROJECT_MANAGERS_INIT:
      return { ...state, addManagerLoading: true, addManagerSuccess: false };
    case types.ADD_PROJECT_MANAGERS_SUCCESS:
      return { ...state, addManagerLoading: false, addManagerSuccess: true };
    case types.ADD_PROJECT_MANAGERS_FAILURE:
      return { ...state, addManagerLoading: false, addManagerSuccess: false };
    default:
      return state;
  }
};

export default projectDetailReducer;
